// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"625":"6b622039","630":"158263ea","861":"e90ccabb"}[chunkId] + ".chunk.js";
};